import React, { FunctionComponent } from 'react';
import Box from '@mui/material/Box';
import { useTheme } from '@mui/material/styles';

type Props = {
    color?: string;
    children: React.ReactNode;
}

const PageContent: FunctionComponent<Props> = ({ color = 'unset', children }) => {
  const theme = useTheme();
  return (<Box sx={{
    minHeight: '100vh',
    backgroundColor: color,
    paddingTop: theme.spacing(10),
    paddingLeft: theme.spacing(2),
    paddingRight: theme.spacing(2),
    paddingBottom: theme.spacing(2)
  }}>
    {children}
  </Box>
  );
}

export default PageContent;